/**
 * Backend-only auto-generated identifier for an element's "Configuration Data" `Title`
 * when left blank — matches the legacy consent editor's behavior exactly
 * (`product/apps` — `packages/econsent-tool/src/views/CkeditorBuilderView/WidgetTemplates/utils.js`
 * `generateUniqueId`, applied identically for Signature/Input/Choice/KnowledgeCheck
 * widgets via `ec__title: values.title || generateUniqueId()` on save).
 *
 * Format: `<epoch-ms>-<counter>`, e.g. `1783836967277-49`. The counter is a simple
 * monotonically increasing in-memory count (mirrors lodash's `uniqueId()`, which the
 * legacy tool uses with no prefix) — it resets on page reload, exactly like the legacy
 * behavior, since it's only meant to disambiguate IDs generated within the same session.
 */
let counter = 0;
export function generateUniqueId() {
    counter += 1;
    return `${Date.now()}-${counter}`;
}
